import * as React from "react";
import { useSelector } from "react-redux";
import { Loader } from "semantic-ui-react";

import { PhysiotherapyMgrReferral } from "@teamprevent/common/physiotherapy/components/PhysiotherapyMgrReferral";
import { PhysiotherapySelfReferral } from "@teamprevent/common/physiotherapy/components/PhysiotherapySelfReferral";
import { QuestionnairesState } from "@teamprevent/common/questionnaires/model";
import {
    selectPhysiotherapyMgrReferralQuestionnaireAsQuestionnaireConfig,
    selectPhysiotherapySelfReferralQuestionnaireAsQuestionnaireConfig
} from "@teamprevent/common/questionnaires/components/physiotherapyReferralForm/selectors";

import { OhCase } from "../../crud/ohCase";
import { PhysiotherapyReferralOrigins } from "../models";
import { ApplicationState } from "../../applicationState";

interface OwnProps {
    api: string;
    documentBaseApi: string;
}

export const ReadonlyPhysiotherapyReferralForm: React.FunctionComponent<OwnProps> = (props: OwnProps) => {

    const ohCaseId: string = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const ohCase: OhCase = useSelector((state: ApplicationState) => state.ohCases?.find(c => c.id === ohCaseId));
    const mgrQuestionnaireConfig = useSelector((state: { questionnaires: QuestionnairesState }) =>
        selectPhysiotherapyMgrReferralQuestionnaireAsQuestionnaireConfig(state));
    const selfQuestionnaireConfig = useSelector((state: { questionnaires: QuestionnairesState }) =>
        selectPhysiotherapySelfReferralQuestionnaireAsQuestionnaireConfig(state));

    const origin = ohCase?.physiotherapyReferralOrigin;

    switch (origin) {
        case PhysiotherapyReferralOrigins.Manager:
            return (
                <PhysiotherapyMgrReferral
                    readonly={true}
                    questionnaireConfig={mgrQuestionnaireConfig}
                    api={props.api}
                    loadOrgStructure={null}
                    documentBaseApi={props.documentBaseApi}
                />
            );
        case PhysiotherapyReferralOrigins.Self:
            return (
                <PhysiotherapySelfReferral
                    readonly={true}
                    questionnaireConfig={selfQuestionnaireConfig}
                    api={props.api}
                    loadOrgStructure={null}
                    documentBaseApi={props.documentBaseApi}
                />
            );
        default: return <Loader active />;
    }
};
